export default { sha: 'ce78a283fa13a573c0c7799c077053526980d62d', buildNumber: 'undefined' }
